function requireAll(r) { r.keys().forEach(r); }

requireAll( require.context( './ico/', true ) );
requireAll( require.context( './png/', true ) );
//requireAll( require.context( './svg/', true, /\.svg$/) );
//requireAll( require.context( './gif/', true, /\.gif$/) );
requireAll( require.context( './fonts/', true ) );